import i18next, { type i18n } from 'i18next';
import ICU from 'i18next-icu';
import { referenceLocale, supportedLocales, type Locale } from './locales';
import { defaultNamespace, resources } from './resources';

/**
 * Creates an isolated, initialised i18next instance using ICU message syntax.
 * Framework-free: the web app binds it to React with `I18nextProvider`.
 */
export async function createI18nInstance(locale: Locale): Promise<i18n> {
  const instance = i18next.createInstance();
  instance.use(ICU);
  await instance.init({
    lng: locale,
    fallbackLng: referenceLocale,
    supportedLngs: [...supportedLocales],
    // Load exactly the regional locale; never fall back to a bare language such as `fr`.
    load: 'currentOnly',
    ns: [defaultNamespace],
    defaultNS: defaultNamespace,
    resources,
    // React escapes output, so i18next must not escape it a second time.
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });
  return instance;
}
